import GetProductFilter from 'dashboard/containers/GetProductFilter';
import React from 'react';

const ProductFilterDashboard = () => <GetProductFilter />;

export default ProductFilterDashboard;
